import { Box, Button, DialogActions } from "@material-ui/core";
import Typography from "legacy-components/typography/Typography";
import { InputContainer } from "modus/components/form/input-container/InputContainer";
import React, { useEffect } from "react";

interface VersionDialogProps {
  version: string;
  onClose: () => void;
  setVersion: (version: string) => void;
  handleSubmit: () => void;
  isLoading?: boolean;
}

export const VersionDialog: React.FC<VersionDialogProps> = ({version, setVersion, handleSubmit, onClose, isLoading = false }) => {

  useEffect(() => {
    return () => {
      setVersion("");
    };
  }, [setVersion]);
    return (
       <>
     <Typography type="body">
          Version
          <span className="required">*</span>
        </Typography>
        <Box display="flex" style={{ marginBottom: "24px" }} flexDirection={"row"} alignItems={"space-between"}>
          <Box
            style={{
              width: "15%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              border: "1px solid #e0e0e0",
              borderRadius: "4px",
              marginRight: "8px",
              marginTop: "9px",
              height: "48px",
            }}
          >
            <Typography type="body">
              <span style={{ color: "#666" }}>v</span>
            </Typography>
          </Box>

          <InputContainer
            required
            placeholder="Enter version number"
            value={version}
            onChange={(e) => setVersion(e.target.value)}
            fullBorder={true}
            validate={{
              required: true,
              minLength: 1,
              pattern: "^[0-9]+$",
              patternMessage: "Please enter only numbers",
            }}
          />
        </Box>

        <DialogActions>
          <Button
            onClick={onClose}
            type="submit"
            variant="outlined"
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            Submit
          </Button>
        </DialogActions> 
        </>
    )

}
 